import React, { useState } from 'react'; // Import useState
import '../styles/PortfolioPage.css';

const PortfolioPage = () => {
    const [selectedImage, setSelectedImage] = useState(null); // State for the selected image

    const projects = [
        // ... your existing projects array ...
        // Example project structure (ensure all your projects are here)
        // {
        //     id: -1,
        //     title: "EVOLUTIONARY SEARCH",
        //     description: "This project tackles the challenge of creating efficient language models for specialized STEM question answering. We enhance a 0.6B parameter model through a multi-faceted approach, exploring MCQA fine-tuning, Direct Preference Optimization (DPO), Retrieval-Augmented Generation (RAG), and a comprehensive suite of quantization techniques.",
        //     date: "2025",
        //     image: "/images/mcqa_llm.jpg",
        //     paperLink: "/reports/mcqa_llm.pdf",
        //     githubLink: "https://github.com/emanuelenevali/mcqa_for_education",
        // },
        {
            id: 12,
            title: "Rate optimal learning of equilibria from data",
            type: "publication",
            venue: "AISTAT 2026 submission",
            description: "We close open theoretical gaps in Multi-Agent Imitation Learning (MAIL) by characterizing the limits of non-interactive MAIL and presenting the first interactive algorithm with nearoptimal sample complexity. In the non-interactive setting, we prove a statistical lower bound that identifies the all-policy deviation concentrability coefficient as the fundamental complexity measure, and we show that Behavior Cloning (BC) is rate-optimal. For the interactive setting, we introduce a framework that combines reward-free reinforcement learning with interactive MAIL and instantiate it with an algorithm, MAIL-WARM. It improves the best previously known sample complexity from O(ε-8) to O(ε-2), matching the dependence on ε implied by our lower bound. Finally, we provide numerical results that support our theory and illustrate, in environments such as grid worlds, where Behavior Cloning fails to learn.",
            date: "2025/2026",
            image: "/images/mail_warm.jpg",
            paperLink: "/reports/mail_warm.pdf",
            githubLink: "https://github.com/emanuelenevali/MAIL_WARM",
        },
        {
            id: 0,
            title: "Sketch-to-Layout: Sketch-Guided Multimodal Layout Generation",
            type: "publication",
            venue: "ICCV 2025 Workshop",
            description: "Graphic layout generation is a growing research area focusing on generating aesthetically pleasing layouts ranging from poster designs to documents. While recent research has explored ways to incorporate user constraints to guide the layout generation, these constraints often require complex specifications which reduce usability. We introduce an innovative approach exploiting user-provided sketches as intuitive constraints and we demonstrate empirically the effectiveness of this new guidance method, establishing the sketch-to-layout problem as an underexplored but promising research direction. To tackle the sketch-to-layout problem, we propose a multimodal transformer-based solution using the sketch and the content assets as inputs to produce high quality layouts. Since collecting sketch training data from human annotators is very costly, we introduce a novel and efficient method to synthetically generate training sketches at scale. We train and evaluate our model on three publicly available datasets: PubLayNet, DocLayNet and SlidesVQA, demonstrating that it outperforms state-of-the-art constraint-based methods, while offering a more intuitive design experience. In order to facilitate future sketch-to-layout research, we release O(200k) synthetically-generated sketches for the public datasets above.",
            date: "2025",
            image: "/images/sketch.jpg",
            paperLink: "/reports/sketch.pdf",
        },
        {
            id: 1,
            title: "Building a Specialized AI Tutor for STEM Education",
            type: "university",
            description: "This project tackles the challenge of creating efficient language models for specialized STEM question answering. We enhance a 0.6B parameter model through a multi-faceted approach, exploring MCQA fine-tuning, Direct Preference Optimization (DPO), Retrieval-Augmented Generation (RAG), and a comprehensive suite of quantization techniques.",
            date: "2025",
            image: "/images/mcqa_llm.jpg",
            paperLink: "/reports/mcqa_llm.pdf",
            githubLink: "https://github.com/emanuelenevali/mcqa_education",
        },
        {
            id: 2,
            title: "Exemplar Image Editing using DiTs",
            type: "university",
            description: "First approach that allows image editing based on another image.",
            date: "2025",
            image: "/images/dit.jpg",
            githubLink: "https://github.com/emanuelenevali/dit-editor",
            paperLink: "/reports/dit_image_editing.pdf"
        },
        {
            id: 3,
            title: "Model Collapse Investigation",
            type: "university",
            description: "Research project investigating Model Collapse in ML systems, with focus on LLM alignment through RLHF. Developed novel rejection sampling techniques that improved catastrophic forgetting by 3x.",
            date: "2023-2024",
            image: "/images/catastrophic_forgetting.jpg",
            githubLink: "https://github.com/CLAIRE-Labo/model-collapse-rlhf",
            paperLink: "/reports/model_collapse.pdf"
        },
        {
            id: 4,
            title: "Poverty Prediction through Satellite Data",
            type: "university",
            description: "Developed scalable machine learning framework to estimate consumption expenditure using satellite images, surveys, and OpenStreetMap features from African countries.",
            date: "2023",
            image: "/images/predicting_poverty.jpg",
            githubLink: "https://github.com/emanuelenevali/predicting-poverty-through-time",
            paperLink: "/reports/predicting_poverty.pdf"
        },
        {
            id: 5,
            title: "BERT to the rescue: factuality in outdated Large Language Models",
            type: "university",
            description: "Method to avoid costly and risky LLM retraining by using a prompt-augmentation strategy to provide up-to-date knowledge. It introduces a BERT-based pruner that efficiently retrieves relevant information from a Knowledge Graph, which demonstrably improves an outdated model's accuracy.",
            date: "2024",
            image: "/images/bert.jpg",
            paperLink: "/reports/bert_factuality.pdf",
        },
        {
            id: 6,
            title: "YouTube: free marketing for everyone",
            type: "university",
            description: "This project analyzes the free marketing that top smartphone companies get from YouTube video coverage. It specifically investigates if Apple's less-is-more product strategy creates a systematic trend in content and viewership compared to its competitors who release more products.",
            date: "2023",
            image: "/images/youtube_marketing.jpg",
            paperLink: "https://ahmad-jarrar.github.io/ada_story/#"
        },
        {
            id: 7,
            title: "Neuralink's Promise and Peril",
            type: "university",
            description: "A philosophical analysis of the conflict between utilitarian progress and the potential erosion of human dignity.",
            date: "2025",
            image: "/images/neuro_ethic.jpg",
            paperLink: "/reports/ethic.pdf"
        },
    ];

    const getLinkHref = (linkPath) => {
    if (!linkPath || linkPath === "coming soon...") {
        return '#'; // Return a placeholder link that does nothing
    }
    if (linkPath.startsWith('http://') || linkPath.startsWith('https://')) {
        return linkPath; // External link
    }
    return process.env.PUBLIC_URL + linkPath; // Internal link
    };

    const openImageModal = (imageSrc) => {
        setSelectedImage(process.env.PUBLIC_URL + imageSrc);
    };

    const closeImageModal = () => {
        setSelectedImage(null);
    };

    return (
        <div className="portfolio-page">
            <div className="portfolio-container">
                {/* ... portfolio-header ... */}
                <div className="portfolio-header">
                    <p>A collection of my research projects and technical work in machine learning, AI, and software engineering.</p>
                </div>

                <div className="projects-grid">
                    {projects.map(project => (
                        <div key={project.id} className="project-card">
                            <div className="project-image"> {/* Remove onClick={() => openImageModal(project.image)} */}
                                <img
                                    src={process.env.PUBLIC_URL + project.image}
                                    alt={project.title}
                                    onLoad={(e) => {
                                        console.log(`Image loaded successfully: ${process.env.PUBLIC_URL + project.image}`);
                                    }}
                                    onError={(e) => {
                                        console.error(`Failed to load image: ${process.env.PUBLIC_URL + project.image}`);
                                        e.target.style.display = 'none';
                                        const fallback = e.target.parentNode.querySelector('.image-fallback');
                                        if (fallback) {
                                            fallback.style.display = 'flex';
                                        }
                                    }}
                                />
                                <div className="image-fallback" style={{display: 'none'}}>
                                    <span>📷</span>
                                    <p>Image not found</p>
                                </div>
                                <div className="project-overlay">
                                    <div className="project-links">
                                        {project.githubLink && (
                                            <a href={project.githubLink} target="_blank" rel="noopener noreferrer" className="project-link">
                                                GitHub
                                            </a>
                                        )}
                                        {project.demoLink && (
                                            <a href={project.demoLink} target="_blank" rel="noopener noreferrer" className="project-link">
                                                Demo
                                            </a>
                                        )}
                                        {project.paperLink && (
                                            <a 
                                                href={getLinkHref(project.paperLink)} 
                                                target={project.paperLink === "coming soon..." ? "_self" : "_blank"} 
                                                rel="noopener noreferrer" 
                                                className="project-link"
                                                onClick={project.paperLink === "coming soon..." ? (e) => e.preventDefault() : undefined}
                                            >
                                                {project.paperLink === "coming soon..." ? "Coming Soon" : "Paper"}
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                            
                            <div className="project-content">
                                <div className="project-type">
                                    {project.type === 'publication' ? (
                                        <span className="type-badge publication">
                                            📄 Publication {project.venue && `(${project.venue})`}
                                        </span>
                                    ) : (
                                        <span className="type-badge university">
                                            🎓 University Project
                                        </span>
                                    )}
                                </div>
                                <div className="project-meta">
                                    <span className="project-date">{project.date}</span>
                                </div>
                                <h3 className="project-title">{project.title}</h3>
                                <p className="project-description">{project.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Image Modal */}
            {selectedImage && (
                <div className="image-modal-overlay" onClick={closeImageModal}>
                    <div className="image-modal-content" onClick={(e) => e.stopPropagation()}> {/* Prevents closing when clicking on image */}
                        <img src={selectedImage} alt="Full view" />
                        <button className="image-modal-close" onClick={closeImageModal}>&times;</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PortfolioPage;